<template>
  <span>{{ $numbers(value).format({ output: 'percent', mantissa: 1, thousandSeparated: true}) }}</span>
</template>

<script>
export default {
  props: ['value']
}
</script>
